import {Action, configureStore, ThunkDispatch} from '@reduxjs/toolkit';
import usersReducer from './slices/users';
import settingsReducer from "./slices/settings";
import rolesReducer from './slices/admin/roles';
import sharedReducer from './slices/admin/shared'
import {TypedUseSelectorHook, useDispatch as useReduxDispatch, useSelector as useReduxSelector} from 'react-redux';
import {rtkApi} from "@/redux/rtk/apiSlice";

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
export type ThunkAppDispatch = ThunkDispatch<RootState, void, Action>;
export const useDispatch: () => ThunkAppDispatch = useReduxDispatch;

export const store = configureStore({
    reducer: {
        users: usersReducer,
        settings: settingsReducer,
        roles: rolesReducer,
        shared: sharedReducer,
        [rtkApi.reducerPath]: rtkApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
            // serializableCheck: {
            //     ignoredActions: [
            //         "rtk-api-slice/executeMutation/pending",
            //         "rtk-api-slice/executeMutation/fulfilled",
            //         "rtk-api-slice/executeMutation/rejected",
            //         "rtk-api-slice/queryResult",
            //     ],
            //     ignoredPaths: ["rtk-api-slice.mutations", "rtk-api-slice.queries"],
            // },
        }).concat(rtkApi.middleware),
});